import React from 'react';
import './LogoBanner.css';

const LogoBanner = () => {
  return (
    <div className="logo-banner">
      <div className="logo-banner-container">
        <img src="/logo.png" alt="Movexa Logo" className="banner-logo" />
        <div className="banner-logo-text">
          <h1>MOVEXA</h1>
          <p>Integrated Solutions</p>
        </div>
      </div>
    </div>
  );
};

export default LogoBanner;
